// file for handling the top filters.
//Import Libraries
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useState } from "react";
import { withRouter } from "react-router";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { config } from "../../../../../config/config";
import { updateAlert, updateAdminInputs } from "../../../../../redux/actions";
import { useUserAuthentication } from "../../../../../utils/utils";
import "../usecaseview.scss";
import Loader from "../../../../../components/Loader/Loader";
import { useHistory } from "react-router-dom";

let api = config.api.api_url;

function MetaSearchFilter(props) {
  let {
    user,
    admin_data,
    updateAdminInputs,
    loading,
    metadataLoading,
    setMetadataLoading,
  } = props;
  let history = useHistory();
  const URL = history?.location?.pathname;
  const Use_Case_Name = URL.split("/").pop();
  const { login } = useUserAuthentication();
  const [expand, setExpand] = useState(false);

  // FETCH META DATA FOR SELECTED DATASET
  const handleDocumentChange = async (e, selectedOption) => {
    setMetadataLoading(true);
    updateAdminInputs("current_document", selectedOption);

    try {
      const params = new URLSearchParams({
        usecase_name: selectedOption?.value || "",
        admin_id: "Retailer_mapping",
      });
      const response = await fetch(
        api + `/admin/retailer_mapping/getmetadatabyid?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });

          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      updateAdminInputs("usecase_metadata", data?.data?.data || {});
      updateAdminInputs("admin_metadata", data?.data?.metadata || {});
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "success",
        closeFlag: true,
      });
    } finally {
      setMetadataLoading(false);
    }
  };

  return (
    <>
      {!expand && (
        <div>
          <>
            {/* DATASETS */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                width: "550px",
              }}
            >
              <div
                style={{
                  minWidth: "120px",
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "#333",
                  whiteSpace: "nowrap",
                }}
              >
                Select Document:{" "}
                <p
                  style={{
                    color: "red",
                    fontSize: 16,
                    display: "inline",
                  }}
                >
                  *
                </p>
              </div>
              <div style={{ flex: 1 }}>
                <Autocomplete
                  id="country-select"
                  disableClearable
                  size="small"
                  options={admin_data?.documents_list || []}
                  loading={loading}
                  loadingText={<Loader />}
                  getOptionLabel={(option) => option.label}
                  onChange={handleDocumentChange}
                  value={admin_data?.current_document || null}
                  popupIcon={
                    <span
                      className="material-icons"
                      style={{
                        fontSize: "20px",
                        color:
                          admin_data.current_document === ""
                            ? "f7f7f7"
                            : "#555",
                      }}
                    >
                      arrow_drop_down
                    </span>
                  }
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#fff",
                      fontFamily: "Hind Siliguri",
                      borderRadius: "6px",
                      fontSize: "13px",
                      fontWeight: "400",
                      color: "#333",
                      height: "36px",
                      paddingRight: "36px", // space for dropdown icon
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "8px 12px",
                    },
                    "& .MuiAutocomplete-endAdornment": {
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)", // vertical center alignment
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#999",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      // label="Select Country"
                      InputLabelProps={{
                        style: {
                          fontSize: "13px",
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{
                        fontSize: "12px",
                        fontWeight: "normal",
                        color: "#212529",
                      }}
                    >
                      {option.label}
                    </li>
                  )}
                />
              </div>
            </div>
          </>
        </div>
      )}
    </>
  );
}

MetaSearchFilter.propTypes = {
  user: PropTypes.object,
  userData: PropTypes.object,
  admin_data: PropTypes.object,
  updateAdminInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.user,
  admin_data: state.admin,
  updateAdminInputs,
});

const mapDispatchToProps = {
  updateAdminInputs,
  updateAlert,
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MetaSearchFilter),
);
